<template>
  <div>
    <div class="warehouseFeeBill">

      <div class="body">
        <div class="total">
          <!-- 总产品数 -->
          <div class="item">
            {{ $t('message.productNumber') }}: <span>{{ detail.goods_count }}</span>
          </div>
          <!-- 总箱数： -->
          <div class="item">
            {{ $t('message.boxNumber') }}: <span>{{ detail.box_count }}</span>
          </div>
          <!--总体积:  -->
          <div class="item">
            {{ $t('message.totalVolume') }}: <span>{{ detail.total_volume }}m³</span>
          </div>
          <!-- 总重量： -->
          <div class="item">
            {{ $t('message.totalWeight') }}: <span>{{ detail.total_weight }}kg</span>
          </div>
          <!-- 总费用： -->
          <div class="item">
            {{ $t('message.totalAmount') }}: <span>{{ detail.total_fee }}円</span>
          </div>
          <!-- 返回 -->
          <el-button type="primary" @click=" $parent.isDetail = false" size="small">
            {{ $t('message.return') }}
          </el-button>
        </div>
        <div class="table">
          <ol style="background-color: #EDEFF4;">
            <li class="flex05"></li>
            <li class="flex05">No</li>
            <!-- 箱号 -->
            <li>{{ $t('message.boxNumber') }}</li>
            <!-- 尺寸(cm) -->
            <li>{{ $t('message.dimension') }}</li>
            <!-- 重量(kg) -->
            <li>{{ $t('message.weight') }}(kg)</li>
            <!-- 箱内SKU数 -->
            <li>{{ $t('message.goodsCount') }}</li>
            <!-- 箱内商品数 -->
            <li>{{ $t('message.goodsNumber') }}</li>
            <!-- 长存仓储费-->
            <li>{{ $t('message.warehouseFeeName') }}</li>
          </ol>
          <div class="detail" v-for="(item, index) in tableData" :key="index">
            <ul>
              <li class="flex05">
                <p style="margin-top: 10px;" class="isShow">
                  <!-- 展开收起 -->
                  <el-button type="info" @click="item.show = !item.show" size="mini">{{ item.show ?
                    $t('message.collapse') :
                    $t('message.expandCollapse') }}
                    <i v-if="!item.show" class="el-icon-arrow-down"></i>
                    <i v-else class="el-icon-arrow-up"></i>
                  </el-button>
                </p>
              </li>
              <li class="flex05">{{ index + 1 }}</li>
              <!-- 箱号 -->
              <li>{{ item.box_no }}</li>
              <!-- 尺寸(cm) -->
              <li>{{ item.c }}*{{ item.k }}*{{ item.g }}</li>
              <!-- 重量(kg) -->
              <li>{{ item.weight }}</li>
              <!-- 箱内SKU数 -->
              <li>{{ item.sku_count }}</li>
              <!-- 箱内商品数 -->
              <li>{{ item.goods_count }}</li>
              <!-- 长存仓储费-->
              <li>{{ item.total_fee }}円</li>
            </ul>
            <el-collapse-transition>
              <div v-show="item.show" class="list">
                <ol style="background: #DCDFE6; color: #666666;">
                  <!-- 订单号 -->
                  <li>{{ $t('message.orderNumber') }}</li>
                  <!-- 番号 -->
                  <li>{{ $t('message.mash') }}</li>
                  <!-- 商品属性 -->
                  <li>{{ $t('message.commodityAttribute') }}</li>
                  <!-- 图片 -->
                  <li>{{ $t('message.pic') }}</li>
                  <!-- 数量 -->
                  <li>{{ $t('message.quantity') }}</li>
                </ol>
                <ul v-for="(goods, goodsIndex) in item.goods_list" :key="goodsIndex">
                  <!-- 订单号 -->
                  <li>
                    <router-link :to="'/orderPaymentDetail?order_sn=' + goods.order_sn" class="a-link" target="_blank">
                      {{ goods.order_sn }}
                    </router-link>
                  </li>
                  <!-- 番号 -->
                  <li>{{ goods.sorting }}</li>
                  <!-- 商品属性 -->
                  <li>
                    <div class="template">
                      <p v-for="(attr, attrIndex) in goods.detail_y" :key="attrIndex">
                        {{ attr.key }}: {{ attr.value }}
                      </p>
                    </div>
                  </li>
                  <!-- 图片 -->
                  <li>
                    <el-image :src="goods.pic" fit="fill" :preview-src-list="[goods.pic]"
                      style="width: 60px; height: 60px;"></el-image>
                  </li>
                  <!-- 数量 -->
                  <li>{{ goods.num }}</li>
                </ul>
              </div>
            </el-collapse-transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      tableData: [],
      detail: {},
      bill_id: '',
    }
  },
  components: {
  },
  methods: {
    // 长存仓库账单-获取详情
    wmsStorageBillDetail() {
      this.$api.costManagementApi.wmsStorageBillDetail({ bill_id: this.bill_id }).then(res => {
        res.data.details.forEach(item => {
          item.show = false
        })
        this.detail = res.data
        this.tableData = res.data.details
      })
    },
  }
}
</script>
<style scoped lang="scss">
.warehouseFeeBill {
  .total {
    display: flex;
    margin-bottom: 20px;
    position: relative;

    .el-button {
      position: absolute;
      right: 0;
    }

    .item {
      margin-right: 50px;
      color: #666666;

      span {
        font-weight: bold;
        margin-left: 5px;
        color: #333333;
      }
    }
  }

  .table {
    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 2;
    }

    ol {
      background: #DCDFE6;
      height: 56px;
      line-height: 56px;
      color: #666666;
    }

    ul {
      padding: 20px 0;
      background-color: #fff;
      text-align: center;

      p {
        line-height: 22px;
        margin-bottom: 6px;

        .el-button {
          width: 80px;
          padding: 11px 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .template {
      width: 100%;


      .row {
        margin-bottom: 12px;
      }
    }
  }

  .isShow {
    text-align: left;

    .el-button {
      background-color: #F6F6F6;
      border: none;
      color: #999999;
      padding: 6px 10px;

      i {
        margin-left: 10px;
      }
    }
  }
}
</style>
